export default __webpack_public_path__ + "static/media/ponto.7b6b2c9f.png";